__turbopack_context__.v({
  "className": "cormorant_garamond_9fad6eda-module__C_7YnW__className",
});
